import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import PaymentReceipt from "../views/PaymentReceipt.vue";
import PaymentRequestP from "../views/PaymentRequest.vue";

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/paymentreceipt',
    name: 'paymentreceipt',
    component: PaymentReceipt
  },
  {
    path: '/paymentrequestp',
    name: 'paymentrequestp',
    props:true,

    component:PaymentRequestP
  },
  // {
  //   path: '/PracticeId:id',
  //   name: 'Home1',
  //   component: Home1
  // },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
